import { render, staticRenderFns } from "./ChatInfo.vue?vue&type=template&id=5629bb0d&scoped=true&"
import script from "./ChatInfo.vue?vue&type=script&lang=js&"
export * from "./ChatInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5629bb0d",
  null
  
)

component.options.__file = "ChatInfo.vue"
export default component.exports